import AlertIcon from '@components/alerticon';
import Typography from '@components/typography';
import { LOGIN, REGISTER, AUTHENDPOINT } from '@navigation/constants';
import { ModalContent } from 'interface';

export const registerLogin = (
  search: string,
  title: string,
  message: string,
  auth: boolean
) => {
  const singleButton = (
    <>
      <a
        href={auth ? AUTHENDPOINT : LOGIN + encodeURIComponent(search)}
        className="modal-content__body-buttons-single-button"
        data-testid="register-login-button"
      >
        <Typography variant="caption" size="rg" weight="semi-bold">
          Log In / Register
        </Typography>
      </a>
    </>
  );

  const multipleButtons = (
    <>
      <a
        href={REGISTER + encodeURIComponent(search)}
        className="
        modal-content__body-buttons-button
        modal-content__body-buttons-button--alternative"
        data-testid="register-login-register-button"
      >
        <Typography variant="caption" size="rg" weight="semi-bold">
          Register
        </Typography>
      </a>
      <a
        href={LOGIN + encodeURIComponent(search)}
        className="
        modal-content__body-buttons-button 
        modal-content__body-buttons-button--primary
        "
        data-testid="register-login-login-button"
      >
        <Typography
          variant="caption"
          size="rg"
          weight="semi-bold"
          colour="alternative"
        >
          Login
        </Typography>
      </a>
    </>
  );

  return {
    icon: auth ? <></> : <AlertIcon />,
    title: title,
    message: message,
    buttons: auth ? singleButton : multipleButtons,
  } as ModalContent;
};
